import { render, staticRenderFns } from "./ic_myProfile.vue?vue&type=template&id=2f80c746&"
import script from "./ic_myProfile.vue?vue&type=script&lang=js&"
export * from "./ic_myProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports